module.exports = __webpack_public_path__ + "static/assets/7b6399d516d5921bb199f57cdd8bbbbe.svg";